import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import * as Sentry from '@sentry/react';
import { AuthProvider } from './providers/auth-provider';

Sentry.init({
  dsn: 'https://0224bd7aacadeaee078a6c082939ed8b@o4508252819685376.ingest.us.sentry.io/4508257986871296',
  integrations: [Sentry.browserTracingIntegration()],
  enabled: process.env.NODE_ENV === 'production',
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/vighwkabyefxwsioxkur\.supabase\.co/],
});

//! Check service worker for updates

createRoot(document.getElementById('root')!).render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
